import { useEffect, useState, useContext } from "react"
import { useNavigate, useSearchParams } from "react-router-dom";
import useErroPadrao from '../../../hooks/useErroPadrao';
import useHelp from '../../../hooks/useHelp';
import { Context } from "../../../context/UsuarioContext";
import { CHAVE_TOKEN } from "../../../utils/formata";
import { podeVer } from "../../../utils/secoes";
import { lerFrequencia, obsComFrequencia } from "../../../utils/cobrancaLote";
import CampoCobranca from "../../Components/CampoCobranca";

const botaoTipo = { display: "inline-flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, minWidth: 0, minHeight: 52, padding: "8px 14px", lineHeight: 1.15, whiteSpace: "nowrap" };
const subBotaoTipo = { fontSize: "0.75rem", fontWeight: 600, opacity: 0.8, letterSpacing: 0.5 };

export default function EmpresaCadastro() {
    const [empresa, setEmpresa] = useState({});
    const [salvando, setSalvando] = useState(false);
    const { consultarEmpresa, adicionarEmpresa } = useHelp();
    const { setErroPadrao } = useErroPadrao();
    const { usuario } = useContext(Context);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const idEdicao = searchParams.get("id");

    // Crédito pessoa física é só da Dani
    const podePF = usuario?.login === "dani";
    const ehPF = empresa.tipoPessoa === "fisica";

    useEffect(() => {
        if (!localStorage.getItem(CHAVE_TOKEN)) {
            navigate("/login");
            return;
        }
        if (idEdicao) {
            consultarEmpresa(idEdicao)
                .then((data) => setEmpresa(data))
                .catch((error) => setErroPadrao(error));
        }
    }, [idEdicao, consultarEmpresa, setErroPadrao, navigate]);

    function handleChange(e) {
        setEmpresa({ ...empresa, [e.target.name]: e.target.value });
    }

    // Pessoa física: o nome vai no razaoSocial (e espelha no responsavel), o CPF vai
    // no cnpj (e espelha no cpfResponsavel) — assim contrato/cobrança/telas continuam
    // funcionando sem saber que é PF.
    function handleNomePF(e) {
        const v = e.target.value;
        setEmpresa({ ...empresa, razaoSocial: v, responsavel: v });
    }
    function handleCpfPF(e) {
        const v = e.target.value;
        setEmpresa({ ...empresa, cnpj: v, cpfResponsavel: v });
    }
    function trocarTipo(tipo) {
        setEmpresa((atual) => ({
            ...atual,
            tipoPessoa: tipo,
            // ao virar PF, garante que o responsavel acompanhe o nome já digitado
            ...(tipo === "fisica" && atual.razaoSocial ? { responsavel: atual.razaoSocial } : {}),
        }));
    }

    function handleSubmit(e) {
        e.preventDefault();
        setSalvando(true);
        adicionarEmpresa(empresa)
            .catch((error) => setErroPadrao(error))
            .finally(() => setSalvando(false));
    }

    return (
        <div className="pagina">
            <h2 className="he-titulo">{idEdicao ? "Editar" : "Novo"} <span className="he-dourado">{ehPF ? "Cliente Pessoa Física" : "Cliente"}</span></h2>

            <form onSubmit={handleSubmit} className="he-card form-mobile" style={{marginTop: "1em"}}>
                {podePF &&
                    <div className="campo-form" style={{marginBottom: "0.5em"}}>
                        <label className="form-label he-dourado">Tipo de cliente</label>
                        <div className="acoes-linha" style={{gap: 8}}>
                            {/* rótulo em duas linhas de propósito: "Pessoa Física (CPF)" numa linha só estourava a tela no celular */}
                            <button type="button" className={`btn ${!ehPF ? "btn-he" : "btn-outline-he"}`} style={botaoTipo} onClick={() => trocarTipo("juridica")}>
                                <span>Empresa</span>
                                <small style={subBotaoTipo}>CNPJ</small>
                            </button>
                            <button type="button" className={`btn ${ehPF ? "btn-he" : "btn-outline-he"}`} style={botaoTipo} onClick={() => trocarTipo("fisica")}>
                                <span>Pessoa Física</span>
                                <small style={subBotaoTipo}>CPF</small>
                            </button>
                        </div>
                        {ehPF && <small style={{color: "#9aa5b5"}}>Crédito pessoa física — a cobrança padrão é <strong className="he-dourado">mensal</strong>.</small>}
                    </div>
                }

                {ehPF ?
                    /* ===== Formulário Pessoa Física ===== */
                    <div className="row">
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">Nome completo *</label>
                            <input className="form-control" name="razaoSocial" value={empresa.razaoSocial || ""} onChange={handleNomePF} required/>
                        </div>
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">CPF</label>
                            <input className="form-control" name="cnpj" value={empresa.cnpj || ""} onChange={handleCpfPF} placeholder="000.000.000-00"/>
                        </div>
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">Telefone / WhatsApp *</label>
                            <input className="form-control" name="telefone" value={empresa.telefone || ""} onChange={handleChange} placeholder="(00) 00000-0000" required/>
                        </div>
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">Renda mensal (R$)</label>
                            <input className="form-control" type="number" step="0.01" name="faturamentoMensal" value={empresa.faturamentoMensal || ""} onChange={handleChange}/>
                        </div>
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">E-mail</label>
                            <input className="form-control" type="email" name="email" value={empresa.email || ""} onChange={handleChange}/>
                        </div>
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">Cidade</label>
                            <input className="form-control" name="cidade" value={empresa.cidade || ""} onChange={handleChange}/>
                        </div>
                        <div className="col-12 campo-form">
                            <label className="form-label he-dourado">Endereço</label>
                            <input className="form-control" name="endereco" value={empresa.endereco || ""} onChange={handleChange}/>
                        </div>
                        <div className="col-12 campo-form">
                            <label className="form-label he-dourado">Cobrança das parcelas</label>
                            <CampoCobranca valor={lerFrequencia(empresa.obs)} onChange={(f) => setEmpresa({ ...empresa, obs: obsComFrequencia(empresa.obs, f) })}/>
                        </div>
                        <div className="col-12 campo-form">
                            <label className="form-label he-dourado">Observações</label>
                            <textarea className="form-control" name="obs" rows={3} value={empresa.obs || ""} onChange={handleChange}></textarea>
                        </div>
                    </div>
                    :
                    /* ===== Formulário Empresa (CNPJ) ===== */
                    <div className="row">
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">Razão Social *</label>
                            <input className="form-control" name="razaoSocial" value={empresa.razaoSocial || ""} onChange={handleChange} required/>
                        </div>
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">Nome Fantasia</label>
                            <input className="form-control" name="nomeFantasia" value={empresa.nomeFantasia || ""} onChange={handleChange}/>
                        </div>
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">CNPJ *</label>
                            <input className="form-control" name="cnpj" value={empresa.cnpj || ""} onChange={handleChange} placeholder="00.000.000/0000-00" required/>
                        </div>
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">Faturamento mensal (R$)</label>
                            <input className="form-control" type="number" step="0.01" name="faturamentoMensal" value={empresa.faturamentoMensal || ""} onChange={handleChange}/>
                        </div>
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">Responsável *</label>
                            <input className="form-control" name="responsavel" value={empresa.responsavel || ""} onChange={handleChange} required/>
                        </div>
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">CPF do Responsável</label>
                            <input className="form-control" name="cpfResponsavel" value={empresa.cpfResponsavel || ""} onChange={handleChange} placeholder="000.000.000-00"/>
                        </div>
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">Telefone / WhatsApp *</label>
                            <input className="form-control" name="telefone" value={empresa.telefone || ""} onChange={handleChange} placeholder="(00) 00000-0000" required/>
                        </div>
                        <div className="col-md-6 campo-form">
                            <label className="form-label he-dourado">E-mail</label>
                            <input className="form-control" type="email" name="email" value={empresa.email || ""} onChange={handleChange}/>
                        </div>
                        <div className="col-md-8 campo-form">
                            <label className="form-label he-dourado">Endereço</label>
                            <input className="form-control" name="endereco" value={empresa.endereco || ""} onChange={handleChange}/>
                        </div>
                        <div className="col-md-4 campo-form">
                            <label className="form-label he-dourado">Cidade</label>
                            <input className="form-control" name="cidade" value={empresa.cidade || ""} onChange={handleChange}/>
                        </div>
                        <div className="col-12 campo-form">
                            <label className="form-label he-dourado">Cobrança das parcelas</label>
                            <CampoCobranca valor={lerFrequencia(empresa.obs)} onChange={(f) => setEmpresa({ ...empresa, obs: obsComFrequencia(empresa.obs, f) })}/>
                        </div>
                        <div className="col-12 campo-form">
                            <label className="form-label he-dourado">Observações</label>
                            <textarea className="form-control" name="obs" rows={3} value={empresa.obs || ""} onChange={handleChange}></textarea>
                        </div>
                    </div>
                }
                <div className="acoes-linha rotulos-longos uma-coluna" style={{justifyContent: "flex-end", marginTop: "1em"}}>
                    {idEdicao && podeVer(usuario, "ia") && String(empresa.telefone || "").replace(/\D/g, "").length >= 8 &&
                        <button type="button" className="btn btn-outline-he" onClick={() => navigate(`/atendimento-ia?grupos=${String(empresa.telefone).replace(/\D/g, "")}`)}>
                            <i className="bi bi-send"></i> Enviar pra grupos
                        </button>}
                    <button type="button" className="btn btn-outline-he" onClick={() => navigate("/empresas")}>Cancelar</button>
                    <button type="submit" className="btn btn-he" disabled={salvando}>
                        {salvando ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-check-lg"></i> {idEdicao ? "Salvar alterações" : ehPF ? "Cadastrar pessoa física" : "Cadastrar empresa"}</>}
                    </button>
                </div>
            </form>
        </div>
    )
}
